import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
  comboContainer: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    '&:hover': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(0, 0, 0, 0.85)'
      }
    }
  },
  active: {
    '& .MuiOutlinedInput-notchedOutline': {
      border: `2px solid ${theme.palette.primary.main}`
    },
    '&:hover': {
      '& .MuiOutlinedInput-notchedOutline': {
        border: `2px solid ${theme.palette.primary.main}`
      }
    }
  },
  error: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.error.main
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.error.main
    },
    '&:hover': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.error.main
      }
    }
  },
  formControl: {
    display: 'flex',
    '& .MuiSelect-icon': {
      height: '2.6rem',
      width: '2.6rem'
    }
  },
  inputControl: {
    flex: 1,
    marginLeft: 0,
    '& .MuiOutlinedInput-notchedOutline': {
      borderLeft: '0 !important',
      borderTopLeftRadius: '0 !important',
      borderBottomLeftRadius: '0 !important'
    }
  },
  selectControl: {
    minWidth: 145,
    '@media(max-width: 480px)': {
      minWidth: 110,
      '& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
        paddingRight: 30
      }
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRight: '0 !important',
      borderTopRightRadius: '0 !important',
      borderBottomRightRadius: '0 !important'
    },
    '&:after': {
      backgroundColor: 'rgba(0, 0, 0, 0.23)',
      content: '""',
      height: 'calc(100% - 20px)',
      position: 'absolute',
      right: 0,
      top: 10,
      width: 1
    }
  },
  helperText: {
    color: '#a4a4a4',
    fontSize: 12,
    marginTop: 5,
    width: '100%'
  },
  stateIcon: {
    backgroundColor: '#FFF',
    borderRadius: 100,
    height: 20,
    padding: 2,
    position: 'absolute',
    right: -8,
    top: -8,
    width: 20
  }
});
